<template>
    <div class="main-cn">
        <div class="main-bd mg20 pro-visible">
            <el-row class="searchSection">
                <el-tabs  v-model="activeTab" @tab-click="handleClick">
                    <el-tab-pane label="跟进解绑规则 " name="1"></el-tab-pane>
                    <el-tab-pane label="禁用规则" name="3"></el-tab-pane>
                    <!-- <el-tab-pane label="个人绑定区域线索自动分配规则" name="4"></el-tab-pane> -->
                    <el-tab-pane label="未绑定区域线索自动分配规则" name="5"></el-tab-pane>
                    <el-tab-pane label="自动分配线索未关联解绑规则" name="6"></el-tab-pane>
                    <!-- <el-tab-pane label="流转客户超时未跟进自动解绑" name="7"></el-tab-pane> -->
                </el-tabs>
            </el-row>
        </div>
        <el-table :data="data" style="width: 100%;margin-left: 20px"  v-loading="loading" class="scrollbar tabTopBorder order-tab-list" 
        v-if="activeTab == '1' || activeTab == '4' || activeTab == '5' || activeTab == '6' || activeTab == '7'" v-watermask>
            <el-table-column label="规则名称" prop="rule_name" >
            </el-table-column>
            <el-table-column label="适用成员" prop="allow_user_rang_text" width="600px">
            </el-table-column>
            <el-table-column label="规则类型" prop="rule_type">
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button v-if="activeTab == '1' || activeTab == '7'" @click="lookLog(scope.row)" type="text" size="small">查看操作日志</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="activeTab == '3'" style="margin-left: 20px">
            <el-row style="margin-bottom: 15px;float: left;">
                <el-button type="primary" @click="dialogFormVisible = true"  size="small">+新增</el-button>
            </el-row>
            <el-row style="float: right;margin-right: 20px">
                <el-button  type="primary" @click="lookLog(3)" style="background-color: darkcyan;border: none"  size="small">查看操作日志</el-button>
            </el-row>
        <el-table :data="data"  v-loading="loading"
                style="width: 99%;">
            <el-table-column
                    prop="rule_name"
                    label="时间段名称">
            </el-table-column>
            <el-table-column
                    prop="day_text"
                    label="禁用解绑规则时间段">
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button @click="disabledhandleUpdate(scope.row)" :disabled="scope.row.is_effect == true" type="text" size="small">编辑</el-button>
                    <el-button @click="deleteRule(scope.row)" :disabled="scope.row.is_effect == true" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>
        </div>
        <el-dialog  :visible.sync="dialogFormVisible" >
            <el-form :model="form" label-width="100px">
                <el-form-item label="时间段名称">
                    <el-input v-model="form.rule_name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label=" 禁用解绑日期">
                    <el-date-picker
                        size="small"
                        type="daterange"
                        unlink-panels
                        v-model="form.time_array"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="禁用类型">
                    <el-checkbox-group v-model="form.disable_type">
                        <el-checkbox label="1">客户自动解绑</el-checkbox>
                        <el-checkbox label="2">线索自动解绑</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <span style="color:red;float:left;">注：禁用解绑日期为开始日期的00:00:00至结束日期后一天的23:59:59</span>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="saveForm" :loading="loading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style>
    .el-table th, .el-table tr,.el-table td { background: #fff; }

</style>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import RuleService from "~/services/Rule";
    export default {
        name: "rule",
        components: {
            Pagination,
        },
        data() {
            return {
                data: [],
                loading: false,
                activeTab: '1',
                orderList: {},
                dialogFormVisible: false,
                form: {
                    id: '',
                    rule_name: '',
                    start_day: '',
                    time_array: '',
                    end_day: '',
                    type: '1',
                    operate_type: '',
                    disable_type: [],
                },
            };
        },
        created() {
            // if(this.$route.query['type'] > 0) this.activeTab = this.$route.query['type'];
            this.initListData();
        },
        beforeRouteUpdate: function (to, from, next) {
            let params = this.searchModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.initListData(params);
        },

        methods: {
            initListData(params = {}) {
                if (this.$router.currentRoute.path == '/login-rules/rule-index') {
                    this.rulelist({
                        type:  this.activeTab
                    });
                }
            },

            rulelist(params) {
                // loading 动画
                this.loading = true;
                RuleService.index(params).then(res => {
                    this.loading = false;
                    this.data = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    return true;
                }).catch(err => {
                    console.error(err);
                })
            },
            handleUpdate(rule) {
                this.$router.push({
                    path: "/login-rules/rule-view",
                    query: {
                        id: rule.id
                    }
                });
            },
            disabledhandleUpdate(rule) {
                this.dialogFormVisible = true;
                RuleService.view( rule.id).then(res => {
                    this.form = res.data;
                    return true;
                }).catch(err => {
                    console.error(err);
                })

            },
            lookLog(rule) {
                if(typeof rule === 'number' ) {
                    this.$router.push({
                        path: "/login-rules/rule-look-logs",
                        query: {
                            type:rule
                        }
                    });
                }else{
                    this.$router.push({
                        path: "/login-rules/rule-look-logs",
                        query: {
                            type:rule.type
                        }
                    });
                }

            },
            deleteRule(rule) {
                this.$confirm("确认要删除该规则？").then(_ => {
                    RuleService.deleteRule(rule.id).then(res => {
                        if (res && res.code == 0) {
                            this.$message.success('删除成功!');
                            this.initListData();
                        }
                    })
                }).catch(err => {
                    console.error(err);
                    return;
                });
            },
            handleClick: function (tab) {
                this.form.type = this.activeTab = tab.name;
                this.rulelist({type: this.activeTab});
            },
            saveForm() {
                this.loading = true;
                if( this.form.id == '') {
                    this.form.operate_type='add';//添加方法
                }
                RuleService.disable_rule_update(this.form).then(res => {
                    if (res && res.code == 0) {
                        this.$message({
                            message: "保存成功!",
                            type: "success",
                            showClose: true,
                        });
                    }
                    this.loading = false;
                    this.rulelist({
                        type:  this.activeTab
                    });
                    this.closeDialog();
                }).catch(() => {
                    this.loading = false;
                });

            },
            closeDialog() {
                this.form = {
                    id: '',
                    rule_name: '',
                    start_day: '',
                    end_day: '',
                    operate_type: 'add',
                    disable_type: [],
                };

                this.dialogFormVisible = false;
            },
            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.rulelist({
                    type: this.activeTab,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/login-rules/rule.vue